import React, { memo } from 'react';
import { CircularProgress } from '@material-ui/core';
import { Box } from "../Box";
function LoadingComponent() {
  return /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    display: "flex",
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(CircularProgress, {
    variant: "indeterminate"
  }));
}
export var Loading = /*#__PURE__*/memo(LoadingComponent);